import React, { useReducer } from "react";
import axios from "axios";
import SubscribeContext from "./SubscribeContext";
import SubscribeReducer from "./SubscribeReducer";
import {
  SUBSCRIBE_CARDS_LOADING,
  SUBSCRIBE_CARDS_LOADED,
  SUBSCRIBE_CARDS_ERROR,
  SUBSCRIBE_RESET_CARDS,
  SET_CURRENT_CARD,
  CLEAR_CURRENT_CARD,
  INIT_SUBSCRIBE,
} from "../types";
import { env } from "../../env";

const API_HOST = env.REACT_APP_HMW_API_HOST_NAME;
// const API_HOST = "";
const SubscribeState = (props) => {
  const initialState = {
    error: null,
    subscribeCards: null,
    changedCards: [],
    subscribeLoading: false,
    subscribeLoaded: false,
    selectedCard: null,
    subscribeRequest: null,
  };
  const [state, dispatch] = useReducer(SubscribeReducer, initialState);

  //Reset Context State
  const resetSubscribeState = () => {
    dispatch({
      type: SUBSCRIBE_RESET_CARDS,
      payload: { ...initialState },
    });
  };

  //Update Card Details
  const updateSubscribeCards = (cards) => {
    dispatch({
      type: SUBSCRIBE_RESET_CARDS,
      payload: { changedCards: cards },
    });
  };

  //Update Card Details
  const initSubscribeCard = (card) => {
    dispatch({
      type: INIT_SUBSCRIBE,
      payload: { subscribeRequest: card },
    });
  };

  //select a card for processing
  const setCurrentCard = (card) => {
    dispatch({
      type: SET_CURRENT_CARD,
      payload: { card },
    });
  };
  //Clear Card Selection
  const clearCurrentCard = () => {
    dispatch({
      type: CLEAR_CURRENT_CARD,
    });
  };

  //Search cards for subscription
  const getSubscribeCards = async (formData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Credentials": "true",
      },
    };
    if (formData) {
      formData.action = "SPONSER_SUBSCRIPTION_MANAGEMENT";
      formData.function = "search";
      formData.version = "1";
    }
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Payload", JSON.stringify(formData));
        dispatch({
          type: SUBSCRIBE_CARDS_LOADING,
        });
        const res = await axios.post(
          `${API_HOST}/rssubscription/search`,
          formData,
          config
        );
        console.log("Cards ", res);
        dispatch({
          type: SUBSCRIBE_CARDS_LOADED,
          payload: res.data,
        });
        resolve(res.data);
      } catch (err) {
        dispatch({
          type: SUBSCRIBE_CARDS_ERROR,
          payload: err,
        });
        reject(err);
      }
    });
  };

  return (
    <SubscribeContext.Provider
      value={{
        ...state,
        resetSubscribeState,
        setCurrentCard,
        clearCurrentCard,
        getSubscribeCards,
        updateSubscribeCards,
        initSubscribeCard,
      }}
    >
      {props.children}
    </SubscribeContext.Provider>
  );
};

export default SubscribeState;
